import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

const BooleanDisplay = (props: { value: boolean | undefined }) => (props.value ? <CheckIcon /> : <CloseIcon />);
export default BooleanDisplay;
